var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({
			    
	// Render
  	render: function(){
  		
  		var categories = this.props.categories.map(function(category, index){
			return (<li key={index}>{category.replace(/&amp;/ig, '&')}</li>);
		});

   		return (
   			<div className="job-categories">
   				<h4>{LanguageStore.get('job_ad/title/categories').toUpperCase()}</h4>
   				<ul className="list">
	   				{categories}
				</ul>
	  		</div>
	  	);
	}
});
